// Location: /themes/memoir/assets/js/components/ui/alert.jsx
import React from 'react';

const Alert = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
    const baseStyles = "relative w-full rounded-lg border p-4";
    const variants = {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
    };

    return React.createElement(
        "div",
        {
            ref: ref,
            role: "alert",
            className: `${baseStyles} ${variants[variant]} ${className}`,
            ...props
        }
    );
});

const AlertDescription = React.forwardRef(({ className, ...props }, ref) =>
    React.createElement(
        "div",
        {
            ref: ref,
            className: `mt-2 text-sm [&_p]:leading-relaxed ${className}`,
            ...props
        }
    )
);

Alert.displayName = "Alert";
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertDescription };